import React from 'react'

const DomainTable = () => (
  <div className="bg-background-secondary flex h-fit w-full flex-col gap-5 overflow-x-hidden rounded-md">
    <div className="flex animate-pulse flex-col gap-7  lg:gap-10 ">
      <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[104px] lg:flex-row lg:gap-10">
        <div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div>
      </div>
    </div>
  </div>
)

export default DomainTable
